import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { Check } from 'lucide-react'
import { API_URL } from '../config'
import Logo from './common/Logo'
import { Spinner } from './ui/spinner'

const WaitlistPage = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)
    
    try {
      const response = await fetch(`${API_URL}/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      })

      const data = await response.json()
      
      if (!response.ok) {
        throw new Error(data.message || 'Failed to join waitlist')
      }

      setIsSubmitted(true)
    } catch (error) {
      setError(error.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black flex items-center justify-center p-4 antialiased">
      <div className="w-full max-w-[400px] mx-auto">
        <div className="relative">
          <div className="flex flex-col items-center space-y-4 mb-8">
            <Logo size="lg" className="mb-2" />
            {/* <h1 className="text-2xl font-bold tracking-tight text-white">
              Join Photowhim Waitlist
            </h1> */}
            <p className="text-sm text-gray-400 text-center">
              Be among the first to experience Photowhim when we launch. Enter your email below to join our waitlist.
            </p>
          </div>

          <div className="bg-gray-800/50 backdrop-blur-xl rounded-xl border border-gray-700 shadow-2xl">
            <div className="p-6">
              {!isSubmitted ? (
                <form onSubmit={handleSubmit} className="space-y-4">
                  {error && (
                    <div className="rounded-lg bg-red-500/10 px-3 py-2 text-sm text-red-400 border border-red-500/20">
                      <p>{error}</p>
                    </div>
                  )}
                  
                  <div className="space-y-2">
                    <label 
                      htmlFor="email" 
                      className="text-sm font-medium text-gray-200"
                    >
                      Email
                    </label>
                    <input
                      id="email"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isLoading}
                      className="flex h-10 w-full rounded-md border border-gray-600 bg-gray-700/50 px-3 py-2 text-sm text-white placeholder:text-gray-400 focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400/20 disabled:cursor-not-allowed disabled:opacity-50"
                      placeholder="Enter your email"
                    />
                  </div>

                  <button
                    type="submit"
                    disabled={isLoading}
                    className="relative w-full rounded-lg bg-white/10 px-4 py-2.5 text-sm font-medium text-white hover:bg-white/20 active:bg-white/25 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center"
                  >
                    {isLoading ? (
                      <>
                        <Spinner className="mr-2" />
                        <span>Joining waitlist...</span>
                      </>
                    ) : (
                      'Join Waitlist'
                    )}
                  </button>
                </form>
              ) : (
                <motion.div 
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="flex flex-col items-center py-4"
                >
                  <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center mb-4">
                    <Check className="w-6 h-6 text-green-400" />
                  </div>
                  <h3 className="text-lg font-medium text-white mb-2">
                    You're on the list!
                  </h3>
                  <p className="text-sm text-gray-400 text-center">
                    Thanks for your interest. We'll notify you when Photowhim is ready.
                  </p>
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WaitlistPage 